import React from 'react';
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from '@mui/material';
import { ITieredEntitySelectionCriterion } from '../../../../common/types/shared/entitySelection';
import { formatCriterionDisplayString } from '../helpers';
import { QueryableFieldsQuery } from '../../../../types/generated-types';

interface CriterionListProps {
  criteria: ITieredEntitySelectionCriterion[];
  selectedCriteria: Set<string>;
  fieldsData: QueryableFieldsQuery['queryableFields'];
  onCriterionSelect: (criterionId: string) => void;
  onCriterionEdit: (criterion: ITieredEntitySelectionCriterion) => void;
}

export const CriterionList: React.FC<CriterionListProps> = ({
  criteria,
  selectedCriteria,
  fieldsData,
  onCriterionSelect,
  onCriterionEdit,
}) => {
  return fieldsData ? (
    <List sx={{ padding: '0px', margin: '0px', overflow: 'auto' }}>
      {criteria.map((criterion) => (
        <ListItemButton
          key={criterion.id}
          onClick={() => onCriterionEdit(criterion)}
        >
          <ListItemIcon>
            <Checkbox
              edge="start"
              checked={selectedCriteria.has(criterion.id)}
              onClick={(e) => {
                e.stopPropagation();
                onCriterionSelect(criterion.id);
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={formatCriterionDisplayString(criterion, fieldsData)}
          />
        </ListItemButton>
      ))}
    </List>
  ) : (
    <div>Loading...</div>
  );
};
